module.exports = __webpack_public_path__ + "static/media/sierra-sedivy.0898f3fd.jpeg";